import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { inject, observer } from 'mobx-react';
import Paper from '@mui/material/Paper';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import Badge from '@mui/material/Badge';
import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
import FavoriteBorderRoundedIcon from '@mui/icons-material/FavoriteBorderRounded';
import ShoppingCartRoundedIcon from '@mui/icons-material/ShoppingCartRounded';
import PersonRoundedIcon from '@mui/icons-material/PersonRounded';

import _useTranslate from '../hooks/_useTranslate';

/*
 * Mobile-only bottom navigation (modern pass). Hidden on desktop via CSS
 * (.bottom-nav { display:none } until <=768px). Tabs map to existing routes;
 * the cart action shows the live cart count; the selected tab colour comes
 * from the app MUI theme (brand). Labels fall back to English when a locale
 * key is missing (same pattern used elsewhere in the app).
 */

const ROUTES = ['/', '/favorites', '/cart', '/account'];

const BottomNav = ({ feathersStore }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const common = _useTranslate(feathersStore.language, 'common');
  const cart = _useTranslate(feathersStore.language, 'cart');
  const account = _useTranslate(feathersStore.language, 'account');

  const current = ROUTES.indexOf(location.pathname);

  return (
    <Paper className="bottom-nav" elevation={0} square>
      <BottomNavigation
        showLabels
        value={current === -1 ? false : current}
        onChange={(e, idx) => navigate(ROUTES[idx])}
        sx={{ height: 62, backgroundColor: 'transparent' }}
      >
        <BottomNavigationAction label={common.home || 'Home'} icon={<HomeRoundedIcon />} />
        <BottomNavigationAction label={account.favorites || 'Favorites'} icon={<FavoriteBorderRoundedIcon />} />
        <BottomNavigationAction
          label={cart.cart || 'Cart'}
          icon={
            <Badge
              badgeContent={feathersStore.cartLength}
              max={99}
              sx={{ '& .MuiBadge-badge': { backgroundColor: 'var(--color-accent)', color: '#fff' } }}
            >
              <ShoppingCartRoundedIcon />
            </Badge>
          }
        />
        <BottomNavigationAction label={account.myAccount || 'Account'} icon={<PersonRoundedIcon />} />
      </BottomNavigation>
    </Paper>
  );
};

export default inject('feathersStore')(observer(BottomNav));
